import { createSelector } from 'reselect';

const getState = (state, query) => ({ features: state.clientConfig, query });

const getClientConfig = createSelector(getState, ({ features = {}, query }) => {
  if (!query) return features;
  const keys = Object.keys(features).filter((key) => key.includes(query));
  const clientConfig = keys.reduce(
    (acc, key) => ({ ...acc, [key]: features[key] }),
    {}
  );
  return clientConfig;
});

const getSpecificClientConfig = createSelector(
  getState,
  ({ features = {}, query }) => {
    if (!query) return false;
    const keys = Object.keys(features).filter((key) => key.includes(query));
    const clientConfig = keys.reduce(
      (acc, key) => ({ ...acc, [key]: features[key] }),
      {}
    );

    if (Object.keys(clientConfig).length === 1)
      return clientConfig[Object.keys(clientConfig)[0]];
    return false;
  }
);

export default {
  getClientConfig,
  getSpecificClientConfig,
};
